<div class="tag-icon-container" *ngIf="!textOnly">
  <mat-icon *ngIf="templateIcon as tIcon; else dotTemplate" class="tag-icon s-1">{{ tIcon }} </mat-icon>
  <ng-template #dotTemplate>
    <div class="tag-dot rounded-full w-[6px] h-[6px]"></div>
  </ng-template>
</div>

<div class="tag-content-container font-black text-[8px] leading-none uppercase pt-[1px]" [class.ml-1]="textOnly">
  <ng-content></ng-content>
  <ng-container *ngIf="displayByType; else labelTemplate">
    <ng-container *ngIf="includeLabelInTranslation; else typeOnlyTemplate">
      {{ typeLabel | transloco : { value: label } }}
    </ng-container>

    <ng-template #typeOnlyTemplate>
      {{ typeLabel | transloco }}
    </ng-template>
  </ng-container>

  <ng-template #labelTemplate>
    {{ label }}
  </ng-template>
</div>
